import React, { useEffect, useState } from 'react';
import Handle from './Handler';
import NodeWrapper from './NodeWrapper';
import Grid from '@material-ui/core/Grid';
import { useSelector } from "react-redux";
import { getTemplateClusterlets } from '../../../../../store/constructs/templated_clusterlet/selectors';
import Icon from './Icon';



const CustomInput = (props) => {

    // console.log('props------->', props)

    let margin = 0;
    const [handlers, setHandlers] = useState([])
    const [displayClass, setDisplayClass] = useState({})
    const templateClusterletInStore = useSelector(getTemplateClusterlets)
    const selectedTemplate = templateClusterletInStore.find(template => template?.id === props?.id)


    useEffect(() => {
        let arr = [];

        if (selectedTemplate?.metajson?.external_clusterlets !== undefined && Object.keys(selectedTemplate?.metajson?.external_clusterlets).length > 0) {
            arr.push({
                connector: 'templateGateway',
                data: {
                    from: [],
                    to: []
                }
            })
        }

        if (props?.data?.handlers !== undefined) {
            for (let [key, value] of Object.entries(props?.data?.handlers)) {
                arr.push({
                    connector: key,
                    data: value
                });
            }
        }


        setHandlers(arr);
    }, []);


    useEffect(() => {

        let classes = [];
        handlers.forEach((item, key) => {
            classes[key] = false;
        });

        setDisplayClass(classes);

    }, [handlers]);

    const displayBox = (key) => {
        setDisplayClass({ ...displayClass, [key]: true });
    }

    const hideBox = (key) => {
        setDisplayClass({ ...displayClass, [key]: false });
    }

    const iconStyle = {
        marginTop: 18,
        width: 30,
        height: 30
    }

    const titleSyle = {
        display: 'block',
        textAlign: 'center',
        marginTop: 13,
        color: '#000',
        fontWeight: 600
    }

    return (
        <NodeWrapper {...props}>

            <div className='template-node'>
                <Grid container spacing={2} alignItems="center">
                    <Icon icon={props.data?.icon ? `data:image/png;base64,${props.data.icon}` : null} defaultIcon={'clusterlet'} type={'template'} />
                </Grid>

            </div>

            {handlers.map((handler, key) => {


                let side = 'left';

                if (key > 0) {
                    if ((key % 4) == 0) side = 'left';
                    else if ((key % 3) == 0) side = 'bottom';
                    else if ((key % 2) == 0) side = 'right';
                    else if ((key % 1) == 0) side = 'top';
                }

                margin = margin + 20;
                return <Handle className={`template-handler template-handler-${side}`} type="source" position={side} id={handler.connector} style={{ top: margin }} connectionMode="loose" onMouseOver={e => displayBox(key)} onMouseOut={e => hideBox(key)}>
                    {displayClass[key] && <div className='template-handler-name-box'>{handler.connector}</div>}
                    <p className="template-handler-text" title={handler.connector}>{handler.connector.charAt(0).toUpperCase()}</p>
                </Handle>
            })}


            {/* <Handle type="source" className="template-handler" position="right" id="right" /> */}
            {/* <Handle type="target" className="template-handler-vertical" position="bottom" id="bottom" /> */}
            <Grid item xs={12}><p style={titleSyle}>{props.data.label}</p></Grid>

        </NodeWrapper>
    );
};

export default CustomInput;
// isValidConnection={validations('source', 'clusterlet')}
